
import {baseUrl,baseUrl2} from '@/api/config.js'

export default{
    
    checkUser:baseUrl+`/call.do?cmd=wechat.checkUser`,   //查询暖暖星球号
    getVipChargeList:baseUrl+`/call.do?cmd=wechat.getNobleChargeList`,  // 查询vip
    getChargeList:baseUrl+`/call.do?cmd=wechat.getChargeList`,  // 钻石列表
    getChargeOrderForNative:baseUrl+`/call.do?cmd=wechat.getChargeOrderForNative`,  // 支付链接
    getChargeOrderForH5:baseUrl+`/call.do?cmd=wechat.getChargeOrderForH5`,  // h5支付链接
    baseSupport:baseUrl+`/call.do?cmd=wechat.baseSupport&type=2`,  // fenx
    listAnchor:baseUrl2+`/WebEntry.web?cmd=event.index&action=listAnchor`,  // 首页图片切换

    login:baseUrl+`/api/pc/user/login`,  // 登录
    getprepare:baseUrl+`/api/pc/live/prepare`,  // 直播预备信息
    startlive:baseUrl+`/api/pc/live/start`,  // 开启直播
    livetitle:baseUrl+`/api/pc/live/title`,  
    livestop:baseUrl+`/api/pc/live/stop`,  
    getIMInfo:baseUrl+`/api/pc/live/getIMInfo`,  
    listHisLiveMsg:baseUrl+`/api/pc/live/listHisLiveMsg`,  
    listAudience:baseUrl+`/api/pc/live/listAudience`,  
    listRank:baseUrl+`/api/pc/live/listRank`,  

};


// WEBPACK FOOTER //
// ./src/api/api_config.js